<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row class="fill-height align-center justify-center text-center">
      <v-col
        cols="12"
        md="8"
        sm="10"
      >
        <div class="text-center">
          <div class="mb-6">
            <v-icon
              color="brand-green"
              size="196"
            >
              {{ $t('Common.Marketplace.MaintenanceMode.Icon') }}
            </v-icon>
          </div>

          <h1 class="brand-text-heading brand-green-dark--text">
            {{ toLocaleUpperCase($t('Common.Marketplace.MaintenanceMode.Title')) }}
          </h1>

          <h4 class="brand-text-small-title brand-green-dark--text mt-4">
            {{ $t('Common.Marketplace.MaintenanceMode.Subtitle') }}
          </h4>

          <div class="mt-12">
            <v-btn
              :disabled="isLoading"
              :loading="isLoading"
              class="white--text"
              color="grey darken-4"
              depressed
              large
              @click="onRetry"
            >
              RETRY
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MaintenanceModeMixin from '@/theme/default/views/maintenance/MaintenanceMode.js'

export default {
  name  : 'MaintenanceMode',
  mixins: [MaintenanceModeMixin]
}
</script>

<style scoped src="@/theme/default/views/maintenance/MaintenanceMode.css"></style>
<style scoped>
</style>
